import path from "path";
import { readFileSync } from "fs";

import { MultiCompiler } from "webpack";
import WebpackDevServer from "webpack-dev-server";

const webpackConfigFile = process.env.webpackConfigFile;
const webpackWorkingDirectory = process.env.webpackWorkingDirectory;
if (process.env.webpackPort == undefined) {
    throw new Error("Should specify webpackPort");
}

const port = parseInt(process.env.webpackPort, 10);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const webpackConfigEnv: any = JSON.parse(process.env.webpackConfigEnv || "{}");

if (process.send == undefined) {
    throw new Error("Should call via node fork");
}

if (webpackWorkingDirectory == undefined) {
    throw new Error("Specify webpackWorkingDirectory");
}

if (webpackConfigFile == undefined) {
    throw new Error("Specify webpackConfigFile");
}

process.chdir(webpackWorkingDirectory);

// eslint-disable-next-line @typescript-eslint/no-require-imports
const engineWebpack = require(path.join(process.cwd(), "node_modules", "webpack"));

// eslint-disable-next-line @typescript-eslint/no-require-imports
const EngineWebpackDevServer: typeof WebpackDevServer = require(
    path.join(process.cwd(), "node_modules", "webpack-dev-server")
);
const devServerVersion = getVersion(path.join(process.cwd(), "node_modules", "webpack-dev-server"));
if (devServerVersion.startsWith("3")) {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    const configs = require(path.join(process.cwd(), webpackConfigFile))(webpackConfigEnv);
    const compiler: MultiCompiler = engineWebpack(configs);
    // @ts-ignore
    const server: WebpackDevServer = new EngineWebpackDevServer(compiler, {
        port: port,
        disableHostCheck: true,
    });
    server.listen(port);
    process.send({ message: "Started" });
} else {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    const configs = require(path.join(process.cwd(), webpackConfigFile))(webpackConfigEnv);
    const compiler: MultiCompiler = engineWebpack(configs);
    // @ts-expect-error Починится, когда все либы обновятся
    const server: WebpackDevServer = new EngineWebpackDevServer(
        {
            port: port,
            allowedHosts: "all",
            server: {
                type: "https",
                options: {
                    cert: require.resolve("../../../../../Keys/localhost.pem"),
                    key: require.resolve("../../../../../Keys/localhost-key.pem"),
                },
            },
            client: {
                overlay: false,
                webSocketURL: `wss://localhost:${port}/ws`,
            },
        },
        compiler
    );
    server.startCallback(() => {
        // @ts-ignore
        process.send({ message: "Started" });
    });
}

export function getVersion(packageDir: string): string {
    const packageJson = JSON.parse(readFileSync(path.join(packageDir, "package.json"), "utf8"));
    return `${packageJson["version"]}`;
}
